module.exports = {"buildVersion":"2.17.9-211129310","release":"2.17.9","buildDateTime":"Mon Nov 29 2021 10:20"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 2099
// module chunks = 23